export const environment = {
  ENV: 'vlt',
  IP_ADDRESS: 'https://pos-vlt.stefdegoey.nl'
};
